import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { Entity, UnallocatedUserId } from '@jms/model';
import { AvatarModule } from '@jms/ui/ui.avatar';

@Component({
    selector: 'entity-item',
    templateUrl: './entity.item.component.html',
    styleUrls: ['./entity.item.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EntityItemComponent implements OnInit {

  @Input() public entity: Entity & { email?: string };
  @Input() public emptyText = 'Not Set';
  @Input() public clearTemplate = false;
  @Input() public showFull = false;
  @Input() public size = 30;


  @Output() public clear = new EventEmitter<any>();
  @Output() public delete = new EventEmitter<Entity>();

  public unallocatedUserId = UnallocatedUserId;


  constructor() { }

  ngOnInit(): void { }

  public onClear(item: any) {
    this.clear.emit(item);
  }

  public onShowFull(show) {
    this.showFull = show;
  }

}

@NgModule({
  imports: [
    CommonModule,
    AvatarModule
  ],
  declarations: [
    EntityItemComponent
  ],
  providers: [],
  exports: [
    EntityItemComponent
  ],
})
export class EntityItemModule { }